export const ContentMimeTypes = [
    "application/pdf",
    "audio/mpeg",
    "audio/mp3",
    "audio/wav",
    "image/png",
    "image/jpeg",
    "image/webp",
    "text/plain",
    "video/mov",
    "video/mpeg",
    "video/mp4",
    "video/avi",
    "video/wmv",
    "video/mpegps",
    "video/flv",
    "video/webm"
];
const CONTENT_MIME_TYPE_SET = new Set(ContentMimeTypes);
export function isContentMimeType(x) {
    return CONTENT_MIME_TYPE_SET.has(x);
}
function getReferenceType(r) {
    if ("TYPE" in r) {
        // legacy
        return r.TYPE;
    }
    return r.type;
}
export function isNLQValueReferenceChart(r) {
    return "values" in r;
}
export function isAnalyticsMetricReferenceChart(r) {
    return getReferenceType(r) == "METRIC";
}
export function isAnalyticsReferenceChart(r) {
    return ("CHART_ID" in r || // legacy check
        "metadata" in r);
}
export function isAnalyticsReferenceValueChart(r) {
    const t = getReferenceType(r);
    return isAnalyticsReferenceChart(r) && (t == "VALUE" || t == "METRIC");
}
export function getAnalyticsReferenceChartReportId(r) {
    if ("nextId" in r) {
        return r.nextId;
    }
    return r.report_id;
}
export function getAnalyticsReferenceChartDatasetId(r) {
    if ("datasetId" in r) {
        return r.datasetId;
    }
    return r.dataset_id;
}
export function getAnalyticsReferenceChartValue(r) {
    if (!isAnalyticsReferenceValueChart(r)) {
        return undefined;
    }
    if ("VALUE" in r) {
        // legacy
        return r.VALUE;
    }
    return r.value;
}
export function isAnalyticsMultiReferenceChart(r) {
    return getReferenceType(r) == "MULTIPLE_CHARTS";
}
export function isDocumentReference(r) {
    return "document" in r;
}
export function isExactDocumentReference(r) {
    return getReferenceType(r) == "EXACT_MATCH";
}
export function isConceptDocumentReference(r) {
    return getReferenceType(r) == "CONCEPT_MATCH";
}
